import { defineMessages } from 'react-intl';

export const statisticMessages = defineMessages({
    paymentStatistics: {
        id: 'payment-statistics',
        defaultMessage: 'Payment statistics',
    },
    monthlyPaymentBreakdown: {
        id: 'monthly-payment-breakdown',
        defaultMessage: 'Monthly payment breakdown',
    },
    visitStatistics: {
        id: 'visit-statistics',
        defaultMessage: 'Visit statistics',
    },
    payments: {
        id: 'payments',
        defaultMessage: 'Payments',
    },
    occupancy: {
        id: 'occupancy',
        defaultMessage: 'Occupancy',
    },
    capacityOverview: {
        id: 'capacity-overview',
        defaultMessage: 'Capacity overview',
    },
    gatewayStatistics: {
        id: 'gateway-statistics',
        defaultMessage: 'Gateway statistics',
    },
    statistics: {
        id: 'statistics',
        defaultMessage: 'Statistics',
    },
    total: {
        id: 'total',
        defaultMessage: 'Total',
    },
    transactions: {
        id: 'transactions',
        defaultMessage: 'Transactions',
    },
    average: {
        id: 'average',
        defaultMessage: 'Average',
    },
    methods: {
        id: 'methods',
        defaultMessage: 'Methods',
    },
    products: {
        id: 'products',
        defaultMessage: 'Products',
    },
    paymentMachines: {
        id: 'payment-machines',
        defaultMessage: 'Payment locations',
    },
    today: {
        id: 'today',
        defaultMessage: 'Today',
    },
    yesterday: {
        id: 'yesterday',
        defaultMessage: 'Yesterday',
    },
    custom: {
        id: 'custom',
        defaultMessage: 'Custom',
    },
    breakdown: {
        id: 'breakdown',
        defaultMessage: 'Breakdown',
    },
    method: {
        id: 'method',
        defaultMessage: 'Method',
    },
    paymentsByMethod: {
        id: 'payments-by-method',
        defaultMessage: 'Payments by method',
    },
    machine: {
        id: 'machine',
        defaultMessage: 'Machine',
    },
    paymentsByMachine: {
        id: 'payments-by-machine',
        defaultMessage: 'Payments by location',
    },
    paymentsByProduct: {
        id: 'payments-by-product',
        defaultMessage: 'Payments by product',
    },
    product: {
        id: 'product',
        defaultMessage: 'Product',
    },
    chooseFilter: {
        id: 'choose-filter',
        defaultMessage: 'Choose filter',
    },
    currency: {
        id: 'currency',
        defaultMessage: 'Currency',
    },
    chooseCurrency: {
        id: 'choose-currency',
        defaultMessage: 'Choose currency',
    },
    noPaymentsFound: {
        id: 'no-payments-found',
        defaultMessage: 'No payments were found',
    },
    chooseDifferentPeriod: {
        id: 'choose-different-period',
        defaultMessage: 'Please choose different period',
    },
    bankPaymentsCount: {
        id: 'bank-payments-count',
        defaultMessage: 'Bank',
    },
    cardPaymentsCount: {
        id: 'card-payments-count',
        defaultMessage: 'Card',
    },
    cashPaymentsCount: {
        id: 'cash-payments-count',
        defaultMessage: 'Cash',
    },
    onlinePaymentsCount: {
        id: 'online-payments-count',
        defaultMessage: 'Online',
    },
    clients: {
        id: 'clients',
        defaultMessage: 'Clients',
    },
    members: {
        id: 'members',
        defaultMessage: 'Members',
    },
    reservations: {
        id: 'reservations',
        defaultMessage: 'Reservations',
    },
    subscriptions: {
        id: 'subscriptions',
        defaultMessage: 'Subscriptions',
    },
    totalVisits: {
        id: 'total-visits',
        defaultMessage: 'Total visits',
    },
    visitsUntil: {
        id: 'visits-until',
        defaultMessage: 'Visits until {time}',
    },
    capacityAt: {
        id: 'capacity-at',
        defaultMessage: 'Capacity at {time}',
    },
    capacityHourlyBreakdownDay: {
        id: 'capacity-hourly-breakdown-day',
        defaultMessage: 'Capacity hourly breakdown for day',
    },
    totalVisitsBreakdownDay: {
        id: 'total-visits-breakdown-day',
        defaultMessage: 'Total visits breakdown for day',
    },
    totalVisitsBreakdownTime: {
        id: 'total-visits-breakdown-time',
        defaultMessage: 'Total visits breakdown at {time}',
    },
    totalPasses: {
        id: 'total-passes',
        defaultMessage: 'Total passes',
    },
    failedPasses: {
        id: 'failed-passes',
        defaultMessage: 'Failed passes',
    },
    failedGatewayPasses: {
        id: 'failed-gateway-passes',
        defaultMessage: 'Failed passes',
    },
    detections: {
        id: 'detections',
        defaultMessage: 'Detections',
    },
    vehiclesPerMinute: {
        id: 'vehicles-per-minute',
        defaultMessage: 'Vehicles/min',
    },
    fromZeroToOne: {
        id: 'from-00-to-01',
        defaultMessage: '00:00 - 01:00',
    },
    fromOneToTwo: {
        id: 'from-01-to-02',
        defaultMessage: '01:00 - 02:00',
    },
    fromTwoToThree: {
        id: 'from-02-to-03',
        defaultMessage: '02:00 - 03:00',
    },
    fromThreeToFour: {
        id: 'from-03-to-04',
        defaultMessage: '03:00 - 04:00',
    },
    fromFourToFive: {
        id: 'from-04-to-05',
        defaultMessage: '04:00 - 05:00',
    },
    fromFiveToSix: {
        id: 'from-05-to-06',
        defaultMessage: '05:00 - 06:00',
    },
    fromSixToSeven: {
        id: 'from-06-to-07',
        defaultMessage: '06:00 - 07:00',
    },
    fromSevenToEight: {
        id: 'from-07-to-08',
        defaultMessage: '07:00 - 08:00',
    },
    fromEightToNine: {
        id: 'from-08-to-09',
        defaultMessage: '08:00 - 09:00',
    },
    fromNineToTen: {
        id: 'from-09-to-10',
        defaultMessage: '09:00 - 10:00',
    },
    fromTenToEleven: {
        id: 'from-10-to-11',
        defaultMessage: '10:00 - 11:00',
    },
    fromElevenToTwelve: {
        id: 'from-11-to-12',
        defaultMessage: '11:00 - 12:00',
    },
    fromTwelveToThirteen: {
        id: 'from-12-to-13',
        defaultMessage: '12:00 - 13:00',
    },
    fromThirteenToFourteen: {
        id: 'from-13-to-14',
        defaultMessage: '13:00 - 14:00',
    },
    fromFourteenToFifteen: {
        id: 'from-14-to-15',
        defaultMessage: '14:00 - 15:00',
    },
    fromFifteenToSixteen: {
        id: 'from-15-to-16',
        defaultMessage: '15:00 - 16:00',
    },
    fromSixteenToSeventeen: {
        id: 'from-16-to-17',
        defaultMessage: '16:00 - 17:00',
    },
    fromSeventeenToEighteen: {
        id: 'from-17-to-18',
        defaultMessage: '17:00 - 18:00',
    },
    fromEighteenToNineteen: {
        id: 'from-18-to-19',
        defaultMessage: '18:00 - 19:00',
    },
    fromNineteenToTwenty: {
        id: 'from-19-to-20',
        defaultMessage: '19:00 - 20:00',
    },
    fromTwentyToTwentyOne: {
        id: 'from-20-to-21',
        defaultMessage: '20:00 - 21:00',
    },
    fromTwentyOneToTwentyTwo: {
        id: 'from-21-to-22',
        defaultMessage: '21:00 - 22:00',
    },
    fromTwentyTwoToTwentyThree: {
        id: 'from-22-to-23',
        defaultMessage: '22:00 - 23:00',
    },
    fromTwentyThreeToZero: {
        id: 'from-23-to-00',
        defaultMessage: '23:00 - 00:00',
    },
    hourlyVisitsBreakdown: {
        id: 'hourly-visits-breakdown',
        defaultMessage: 'Hourly visits breakdown',
    },
    durationBreakdown: {
        id: 'duration-breakdown',
        defaultMessage: 'Duration breakdown',
    },
    underFifteenMinutes: {
        id: 'under-15m',
        defaultMessage: 'Under 15 min',
    },
    betweenFifteenAndThirtyMinutes: {
        id: 'between-15m-and-30m',
        defaultMessage: 'Between 15 min and 30 min',
    },
    betweenThirtyMinutesAndHour: {
        id: 'between-30m-and-1h',
        defaultMessage: 'Between 30 min and 1 hour',
    },
    betweenHourAndTwo: {
        id: 'between-1h-and-2h',
        defaultMessage: 'Between 1 and 2 hours',
    },
    betweenTwoAndThreeHours: {
        id: 'between-2h-and-3h',
        defaultMessage: 'Between 2 and 3 hours',
    },
    betweenThreeAndFourHours: {
        id: 'between-3h-and-4h',
        defaultMessage: 'Between 3 and 4 hours',
    },
    betweenFourAndFiveHours: {
        id: 'between-4h-and-5h',
        defaultMessage: 'Between 4 and 5 hours',
    },
    betweenFiveAndSixHours: {
        id: 'between-5h-and-6h',
        defaultMessage: 'Between 5 and 6 hours',
    },
    betweenSixAndSevenHours: {
        id: 'between-6h-and-7h',
        defaultMessage: 'Between 6 and 7 hours',
    },
    betweenSevenAndEightHours: {
        id: 'between-7h-and-8h',
        defaultMessage: 'Between 7 and 8 hours',
    },
    betweenEightAndNineHours: {
        id: 'between-8h-and-9h',
        defaultMessage: 'Between 8 and 9 hours',
    },
    moreThanNineHours: {
        id: 'more-than-9h',
        defaultMessage: 'More than 9 hours',
    },
    visitors: {
        id: 'visitors',
        defaultMessage: 'Visitors',
    },
    operations: {
        id: 'operations',
        defaultMessage: 'Operations',
    },
    validations: {
        id: 'validations',
        defaultMessage: 'Validations',
    },
    timestamp: {
        id: 'timestamp',
        defaultMessage: 'Timestamp',
    },
    validationAccount: {
        id: 'validation-account',
        defaultMessage: 'Validation account',
    },
    validationType: {
        id: 'validation-type',
        defaultMessage: 'Validation type',
    },
    amount: {
        id: 'amount',
        defaultMessage: 'Amount',
    },
    validatedBy: {
        id: 'validated-by',
        defaultMessage: 'Validated by',
    },
    activeStayPeriod: {
        id: 'active-stay-period',
        defaultMessage: 'Active stay period',
    },
    pastStayPeriod: {
        id: 'past-stay-period',
        defaultMessage: 'Past stay period',
    },
    visitor: {
        id: 'visitor',
        defaultMessage: 'Visitor',
    },
    owner: {
        id: 'owner',
        defaultMessage: 'Owner',
    },
    allZones: {
        id: 'all-zones',
        defaultMessage: 'All zones',
    },
    chooseZone: {
        id: 'choose-zone',
        defaultMessage: 'Choose zone',
    },
    freeClientSpaces: {
        id: 'free-client-spaces',
        defaultMessage: 'Free client spaces',
    },
    freeMemberSpaces: {
        id: 'free-member-spaces',
        defaultMessage: 'Free member spaces',
    },
    freeReservationSpaces: {
        id: 'free-reservation-spaces',
        defaultMessage: 'Free reservation spaces',
    },
    freeSubscriptionSpaces: {
        id: 'free-subscription-spaces',
        defaultMessage: 'Free subscription spaces',
    },
    freeSpacesCount: {
        id: 'free-spaces-count',
        defaultMessage: 'Free spaces count',
    },
    totalFreeSpacesCount: {
        id: 'total-free-spaces-count',
        defaultMessage: 'Total free spaces count',
    },
    totalAmount: {
        id: 'total-amount',
        defaultMessage: 'Total amount',
    },
    averageDuration: {
        id: 'average-duration',
        defaultMessage: 'Average duration',
    },
    paymentLocation: {
        id: 'payment-location',
        defaultMessage: 'Location',
    },
    totalTime: {
        id: 'total-time',
        defaultMessage: 'Total time',
    },
    validationAccounts: {
        id: 'validation-accounts',
        defaultMessage: 'Validation accounts',
    },
    validationTypes: {
        id: 'validation-types',
        defaultMessage: 'Validation types',
    },
    totalValidations: {
        id: 'total-validations',
        defaultMessage: 'Total validations',
    },
    allVisits: {
        id: 'all-visits',
        defaultMessage: 'All visits',
    },
    vehiclesPerHour: {
        id: 'vehicles-per-hour',
        defaultMessage: 'Vehicles/hour',
    },
    passes: {
        id: 'passes',
        defaultMessage: 'Passes',
    },
});
